<template>
  <div id="app">
    <!-- <div v-if="$route.meta.keepAlive"> -->
    <div class="pageWinthOver" v-if="$route.meta.menu">
      <Menu @change="change" />
    </div>
    <!-- </div> -->
    <router-view />
    <!-- footer -->
    <Footer v-if="$route.meta.breadcrumb !='地图' && $route.meta.breadcrumb !='个人中心'"></Footer>
  </div>
</template>

<script>
window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
import Menu from "@/components/header/menu.vue";
import Footer from "@/components/footer/index.vue";
export default {
  name: "App",
  components: {
    Menu,
    Footer
  },
  provide() {
    return {
    }
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {

    change(key) {
      // console.log(key)
      // if(keyPath[0] == '/industrymap'){location.reload()}
    },
    changepage(val) {
      // setTimeout(()=>{
      //   if(val[0] == '/industrymap'){location.reload()}
      // },300)
    }
  }
};
</script>

<style>
#app {
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  /* -webkit-font-smoothing: antialiased; */
  /* -moz-osx-font-smoothing: grayscale; */
  color: #2c3e50;
}

* {
  padding: 0;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue